import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { WarningIcon } from "../../assets/iconComponents/Warning";
import { themePalette } from "../../theme";
import {
  NewReqRequiredMessage,
  BoldText,
  StyledRedSpan,
} from "./NewRequisition.styles";

type NewReqRequiredFieldsMessageProps = {
  isError: boolean;
};

const NewReqRequiredFieldsMessage = ({
  isError,
}: NewReqRequiredFieldsMessageProps) => (
  <NewReqRequiredMessage $isError={isError}>
    {isError ? (
      <WarningIcon testId="WarningIcon" />
    ) : (
      <FontAwesomeIcon
        icon={faCircleInfo}
        color={themePalette.blueDark}
        fontSize={16}
        aria-hidden
      />
    )}
    <BoldText>
      Please fill out all required fields marked with an asterisk (
      <StyledRedSpan>*</StyledRedSpan>)
    </BoldText>
  </NewReqRequiredMessage>
);

export default NewReqRequiredFieldsMessage;
